import PropTypes from 'prop-types';
import React from 'react';
import { t } from '../../../../modules/infra/i18n';
import AddCustomerModal from '../../../common/customer/AddCustomerModal';

const NewCustomer = ({ on, off, isOn, onAfterSubmit }) => (
  <div>
    <button
      type="button"
      className="c-btn c-btn--medium u-height-40"
      onClick={on}
    >
      {t('register:payment.new_customer.new_button')}
    </button>
    <AddCustomerModal
      close={off}
      onAfterSubmit={onAfterSubmit}
      display-if={isOn}
    />
  </div>
);
NewCustomer.propTypes = {
  on: PropTypes.func.isRequired,
  off: PropTypes.func.isRequired,
  isOn: PropTypes.bool.isRequired,
  onAfterSubmit: PropTypes.func.isRequired,
};
NewCustomer.defaultProps = {};

export default NewCustomer;
